import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./instruction_download.module.scss";
import { MdPictureAsPdf } from "react-icons/md";
import { getAssets, htmlParse } from "@unisearch/helpers";
import { FiChevronRight } from "react-icons/fi";
import { ReactSVG } from "react-svg";

// This component takes props
// -> shortDescription
// -> heading
// -> as (download, link, button etc)
// -> buttonTitle

export const InstructionDownload = (props) => {
  return (
    <section className={styles.section_instruction_download}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={`${styles.title_wrapper}`}>
            <p className={`${styles.sub_title} sub_title`}>
              {props.shortDescription}
            </p>
            {props.heading && (
              <h2 className={`${styles.title} fw400`}>
                {htmlParse(props.heading)}
              </h2>
            )}
          </div>

          <div className={styles.button_wrapper}>
            {props.as === "download" && (
              <Link legacyBehavior href={props.link}>
                <a className="btn btn-primary btn-bg" download target="_blank">
                  <MdPictureAsPdf /> {props.buttonTitle}
                </a>
              </Link>
            )}

            {props.as === "link" && (
              <Link legacyBehavior href={props.link}>
                <a className="btn btn-primary btn-bg">
                  {props.buttonTitle}
                  <FiChevronRight />
                </a>
              </Link>
            )}
            {props.as === "video-link" && (
              <Link legacyBehavior href={props.link}>
                <a className="btn btn-secondary btn-bg">
                  <ReactSVG
                    style={{ height: "22px" }}
                    src={getAssets("assets/icons/video-chat-icon-white.svg")}
                  />
                  {props.buttonTitle}
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstructionDownload;
